function BusComponent($filter, $http, AppConstants) {
	'ngInject';

	const service = {
		fetchBuses: fetchBuses,
		fetchBusesByDate: fetchBusesByDate,
		fetchWaibillByDate: fetchWaibillByDate,
		fetchBus: fetchBus,
		fetchWaybill: fetchWaybill,
		fetchAgreedSeats: fetchAgreedSeats,
		getBuses: getBuses,
		getBus: getBus,
		getAgreedSeats: getAgreedSeats, 
		createBus: createBus,
		createAgreedSeats: createAgreedSeats,
		updateBus: updateBus,
		updateWaybill: updateWaybill,
		deleteBus: deleteBus,
		clearBuses: clearBuses
	};

	let buses = [];
	let bus = {};
	let agreedSeats = [];

	return service;

	/** */
	function createAgreedSeats(busId, seats) {
		const params = {
			'agreed_seats': seats,
			'bus_id': busId
		};

		return 	$http.post(`${AppConstants.apiUrl}/agreed-seats`, params)
			.then(function() {
			})
			.catch(function(err) {
				console.log(err);
			});
	}
	
	function fetchAgreedSeats(searchParams) {
		return $http.get(`${AppConstants.apiUrl}/agreed-seats`, {
			'params': {
				bus_id: searchParams.bus_id
			}
		})
			.then(setAgreedSeats)
			.catch(failedRequest);
	}
	
	function fetchBuses(lineId, sort = '-id', limit = '') {
		return $http.get(`${AppConstants.apiUrl}/buses`, {
			'params': {
				sort,
				limit,
				'line_id': lineId,
				'with': 'stations,days,line'
			}
		})
			.then(setBuses)
			.catch(failedRequest);
	}

	function fetchBusesByDate(date, sort = '-id') {
		return $http.get(`${AppConstants.apiUrl}/buses`, {
			'params': {
				sort,
				'departs_at': date,
				'with': 'stations,line'
			}
		})
			.then(setBuses)
			.catch(failedRequest);
	}

	function fetchWaibillByDate(date, sort = '-id') {
		return $http.get(`${AppConstants.apiUrl}/waybills`, {
			'params': {
				sort,
				'departs_at': date,
				'with': 'stations,line'
			}
		})
			.then(setBuses)
			.catch(failedRequest);
	}

	function fetchBus(id, date, relations = 'translations,country') {
		return $http.get(`${AppConstants.apiUrl}/buses/${id}`, {
			'params': {
				date,
				'with': relations
			},
			'config': {
				headers: {
					'Accept-Language': 'en'
				}
			}
		})
			.then(setBus)
			.catch(failedRequest);
	}

	function fetchWaybill(busId, date) {
		return $http.get(`${AppConstants.apiUrl}/waybills/${ busId }`, {
			'params': {
				date,
				'sort': 'number'
			}
		})
			.then(successRequest)
			.catch(failedRequest);
	}

	function setBuses(response) {
		buses = response.data.data;

		return buses;
	}

	function setBus(response) {
		if (response.data && response.data.errors) {
			bus = response;
		} else {
			bus = response.data.data;
		}

		return bus;
	}

	function getBuses() {
		return buses;
	}

	function getBus() {
		return bus;
	}

	function createBus(params) {
		return $http.post(`${AppConstants.apiUrl}/buses`, params)
			.then(successRequest)
			.catch(failedRequest);
	}

	function updateBus(id, params) {
		return $http.put(`${AppConstants.apiUrl}/buses/${id}`, params)
			.then(successRequest)
			.catch(failedRequest);
	}

	function deleteBus(id) {
		return $http.delete(`${AppConstants.apiUrl}/buses/${id}`)
			.then(successRequest)
			.catch(failedRequest);
	}
	
	function updateWaybill(id, params) {
		return $http.put(`${AppConstants.apiUrl}/waybills/${id}`, params)
			.then(successRequest)
			.catch(failedRequest);
	}

	function successRequest(response) {
		return response;
	}

	function failedRequest(requestError) {
		console.log(requestError);

		return requestError;
	}

	function clearBuses() {
		buses = [];
	}
	
	function getAgreedSeats() {
		return agreedSeats;
	}
	
	function setAgreedSeats(response) {
		agreedSeats = response.data.data;

		return agreedSeats;
	}
}
export default BusComponent;



/** WEBPACK FOOTER **
 ** ./client/components/bus/bus.service.js
 **/